import _throttle from 'lodash/throttle'
const throttle = (Vue)=> {

    Vue.directive('throttle', {
        inserted(el, binding) {
            el.onclick = _throttle(binding.value,binding.arg || 1000,{leading:true,trailing:false})
        }
    })
}
export default throttle



//////////////////
// WEBPACK FOOTER
// ./node_modules/@mxc/v-directive/utils/throttle.js
// module id = null
// module chunks = 